export const CUSTOMER_SHARE_TOOLS_PATH = '/customer-share-tools'
export const MOBILE_SHARE_TOOLS_MAX_WIDTH = 720

export function normalizeRoutePath(path) {
  const raw = String(path || '').split('?')[0].split('#')[0]
  if (!raw || raw === '/') return raw || '/'
  return raw.replace(/\/+$/, '')
}

export function isCustomerShareToolsPath(path) {
  return normalizeRoutePath(path) === CUSTOMER_SHARE_TOOLS_PATH
}

export function isMobileViewportWidth(width) {
  return Number(width) <= MOBILE_SHARE_TOOLS_MAX_WIDTH
}

export function getViewportWidth(win) {
  const target = win || (typeof window !== 'undefined' ? window : null)
  if (!target) return Number.POSITIVE_INFINITY
  return target.innerWidth || (target.document && target.document.documentElement && target.document.documentElement.clientWidth) || Number.POSITIVE_INFINITY
}

export function shouldUseMobileShareToolsMode(path, viewportWidth) {
  return isCustomerShareToolsPath(path) && isMobileViewportWidth(viewportWidth)
}

export function shouldLockMobileShareToolsNavigation(fromPath, toPath, viewportWidth) {
  if (!shouldUseMobileShareToolsMode(fromPath, viewportWidth)) return false
  if (normalizeRoutePath(toPath) === '/login') return false
  return !isCustomerShareToolsPath(toPath)
}
